// extracted by mini-css-extract-plugin
export var attachButton = "_ee-8";
export var sendButton = "_ee-2";
export var sendDisabled = "_ee-4";
export var sendEnabled = "_ee-3";
export var sendIcon = "_ee-6";
export var sendIconDisabled = "_ee-7";
export var sendStreaming = "_ee-5";
export var textarea = "_ee-1";
export var wrapper = "_ee-0";